import { HttpService, Query, QueryHandler, TaggedUrl, Tags } from '@skylab-shared/core';
import { PagedCollectionQueryResult } from '../common/query/paged-collection-query';

export interface OnlineReceiversItem {
    readonly id: string;
    readonly channelId: string;
    readonly companyName: string;
    readonly instanceName: string;
    readonly name: string;
}

export class OnlineReceiversQuery extends Query<OnlineReceiversItem[]> { }

export class OnlineReceiversQueryHandlerBase implements QueryHandler<OnlineReceiversQuery, OnlineReceiversItem[]> {
    public static Url = TaggedUrl.join('accounting/onlineReceivers', [Tags.Api]);

    public constructor(private readonly http: HttpService) { }

    public async handleAsync(_: OnlineReceiversQuery): Promise<OnlineReceiversItem[]> {
        const { data } = await this.http.get<PagedCollectionQueryResult<OnlineReceiversItem>>(OnlineReceiversQueryHandlerBase.Url);
        return data.items.map(item => ({
            id: item.id,
            channelId: item.channelId,
            name: item.name,
            instanceName: item.instanceName,
            companyName: item.companyName,
        }));
    }
}
